<template>
    <k-page>
        <template v-slot:header>
            <public-header/>
        </template>
        <complete-email-verification-form/>
        <template v-slot:footer>
            <k-footer/>
        </template>
    </k-page>
</template>

<script>
    import PublicHeader from '@investor/components/PublicHeader';
    import CompleteEmailVerificationForm from '@investor/components/registration/CompleteEmailVerificationForm';

    export default {
        components: {
            CompleteEmailVerificationForm,
            PublicHeader,
        }
    }
</script>


